import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalSmsPageRoutingModule } from './modal-sms-routing.module';

import { ModalSmsPage } from './modal-sms.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalSmsPageRoutingModule
  ],
  declarations: [ModalSmsPage]
})
export class ModalSmsPageModule {}
